module.exports = __webpack_public_path__ + "img/LogotipoCompleto.2fcae315.png";